//Reset data
export const RESET = "USER_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "USER_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USER_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USER_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USER_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "USER_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USER_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USER_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "USER_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USER_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "USER_SHOW_SET_ITEMS"
export const SET_CARACTERISATIONS = "USER_SHOW_SET_CARACTERISATIONS"
export const SET_CURRENT_ITEM = "USER_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USER_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USER_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USER_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "USER_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "USER_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USER_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USER_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USER_SHOW_SET_MODAL_TYPE"